import ProfileDTO from "../../domain/dto/profileDTO";
import CorrespondingEntity from "../../domain/entities/correspondingEntity";
import Profile from "../../domain/entities/profile";
import User from "../../domain/entities/user";
import Http from "../../http/http";
import HttpRequest from "../../http/httpRequest";
import ApiRoutes from "../../http/routes";
import UploadImageProvider from "../provider/uploadImageProvider";

export default class UserRepository {
  private static instance: UserRepository | null = null;
  private uploadImageProvider: UploadImageProvider;

  constructor(private http: Http) {
    this.uploadImageProvider = UploadImageProvider.getInstance();
  }

  static getInstance(http: Http): UserRepository {
    if (!UserRepository.instance) {
      UserRepository.instance = new UserRepository(http);
    }
    return UserRepository.instance;
  }

  async getUserByDocument(document: string): Promise<Profile> {
    const request = new HttpRequest(ApiRoutes.user, undefined, { document });

    const response = await this.http.get<User>(request);
    return ProfileDTO.fromJson(response);
  }

  async checkUserExists(
    email: string,
    document: string
  ): Promise<{ emailExists: boolean; documentExists: boolean }> {
    const request = new HttpRequest(ApiRoutes.userCheckExists, undefined, {
      email,
      document,
    });
    return await this.http.get<{
      emailExists: boolean;
      documentExists: boolean;
    }>(request);
  }

  async getUsers(): Promise<CorrespondingEntity[]> {
    const response = await this.http.get<{ data: CorrespondingEntity[] }>(
      new HttpRequest(ApiRoutes.user)
    );
    return response.data;
  }

  async createUser(user: CorrespondingEntity) {
    // Garantir que linkedVentures seja sempre um array
    const linkedVentures = Array.isArray(user.linkedVentures)
      ? user.linkedVentures
      : [];

    // Verificação adicional para garantir que seja um array válido
    const assignedEnterprises = linkedVentures.filter(
      (item) => item !== null && item !== undefined
    );

    const payload = {
      userType: user.userType,
      name: user.namePersonResponsible,
      socialName: user.companyName,
      document: user.documentName,
      email: user.email,
      assignedEnterprises: assignedEnterprises,
    };

    console.log("Payload sendo enviado para o backend:", payload);
    console.log(
      "Tipo de assignedEnterprises:",
      typeof payload.assignedEnterprises
    );
    console.log("É array?", Array.isArray(payload.assignedEnterprises));
    console.log("Valor de assignedEnterprises:", payload.assignedEnterprises);

    const request = new HttpRequest(ApiRoutes.user, payload);
    return await this.http.post<void>(request);
  }

  async updateUser(user: CorrespondingEntity) {
    // Garantir que linkedVentures seja sempre um array
    const linkedVentures = Array.isArray(user.linkedVentures)
      ? user.linkedVentures
      : [];

    // Verificação adicional para garantir que seja um array válido
    const assignedEnterprises = linkedVentures.filter(
      (item) => item !== null && item !== undefined
    );

    const payload = {
      userType: user.userType,
      name: user.namePersonResponsible,
      socialName: user.companyName,
      document: user.documentName,
      email: user.email,
      assignedEnterprises: assignedEnterprises,
    };

    const request = new HttpRequest(`${ApiRoutes.user}/${user.id}`, payload);
    return await this.http.put<void>(request);
  }

  async updateUserStatus(userId: string, status: string) {
    const request = new HttpRequest(`${ApiRoutes.user}/${userId}/status`, {
      status,
    });
    return await this.http.put<void>(request);
  }

  async getCurrentUser(): Promise<Profile> {
    const request = new HttpRequest(ApiRoutes.me);
    const response = await this.http.get<any>(request);
    return ProfileDTO.fromJson(response);
  }

  async updateCurrentUser(data: {
    name?: string;
    email?: string;
  }): Promise<void> {
    const request = new HttpRequest(ApiRoutes.me, data);
    await this.http.put<void>(request);
  }

  async uploadProfilePhoto(file: File): Promise<void> {
    if (file.size > 2 * 1024 * 1024) {
      throw new Error("Arquivo muito grande. Máximo 2MB permitido.");
    }

    try {
      const imageUrl = await this.uploadImageProvider.upload(file);
      const payload = { imageLink: imageUrl };

      const request = new HttpRequest(ApiRoutes.mePhoto, payload);
      await this.http.post(request);
    } catch (error) {
      throw error;
    }
  }

  async deleteProfilePhoto(): Promise<void> {
    const request = new HttpRequest(ApiRoutes.mePhoto);
    return await this.http.delete(request);
  }

  async changePassword(userId: string, password: string) {
    debugger;
    const request = new HttpRequest(
      `${ApiRoutes.userChangePassword.replace("{id}", userId)}`,
      { newPassword: password }
    );
    return await this.http.put(request);
  }
}
